module.exports = __webpack_public_path__ + "224623b0ba9eb7e26f8539867aaf88e3.jpg";